/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum ReferralLevel {
  STARTER = 'STARTER',
  PARTNER = 'PARTNER',
  PRO = 'PRO',
  VIP = 'VIP',
  ELITE = 'ELITE',
  MAX = 'MAX',
}

export function ReferralLevelFromJSON(json: any): ReferralLevel {
  return ReferralLevelFromJSONTyped(json, false)
}

export function ReferralLevelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralLevel {
  return json as ReferralLevel
}

export function ReferralLevelToJSON(value?: ReferralLevel | null): any {
  return value as any
}
